import React from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { colors } from '../styles/global';

const AppointmentItem = ({ client, time, service, status }) => (
  <View style={styles.appointmentItem}>
    <View style={styles.appointmentInfo}>
      <Text style={styles.clientName}>{client}</Text>
      <Text style={styles.serviceInfo}>{service} • {time}</Text>
    </View>
    <View style={[styles.statusBadge, styles[`status_${status}`]]}>
      <Text style={styles.statusText}>{status}</Text>
    </View>
  </View>
);

export const AppointmentsList = ({ appointments, onSeeAll }) => {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>Próximos Agendamentos</Text>
        <TouchableOpacity onPress={onSeeAll}>
          <Text style={styles.seeAllButton}>Ver todos</Text>
        </TouchableOpacity>
      </View>
      <ScrollView style={styles.list}>
        {appointments.map((appointment, index) => (
          <AppointmentItem key={index} {...appointment} />
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    borderRadius: 10,
    padding: 15,
    maxHeight: 400,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: colors.text,
  },
  seeAllButton: {
    color: colors.primary,
    fontSize: 14,
  },
  list: {
    flex: 1,
  },
  appointmentItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  appointmentInfo: {
    flex: 1,
  },
  clientName: {
    fontSize: 16,
    fontWeight: '500',
    color: colors.text,
    marginBottom: 4,
  },
  serviceInfo: {
    fontSize: 14,
    color: colors.textLight,
  },
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 15,
    marginLeft: 10,
  },
  statusText: {
    fontSize: 12,
    fontWeight: '500',
  },
  status_confirmado: {
    backgroundColor: colors.success + '20',
  },
  status_pendente: {
    backgroundColor: colors.warning + '20',
  },
  status_cancelado: {
    backgroundColor: colors.error + '20',
  },
});